import React, { MouseEventHandler, useEffect, useState } from "react";
import { shallowEqual } from "react-redux";
import { useAppSelector } from "src/store/actions/action";
import moment from "moment";
import PaginationCommon from "../common/PaginationCommon";
import StatusTag from "../common/StatusTag";
import SVG from "src/utils/SVG";
import cn from "classnames";
import styled from "styled-components";

interface ListProp {
  data?: any;
  currentPage?: number;
  onClick?: MouseEventHandler<HTMLButtonElement> | any;
  asDetailClick?: MouseEventHandler<HTMLButtonElement> | any;
}

const AsListItem = (props: ListProp) => {
  const userInfo = useAppSelector((state) => state.userReduce.userInfo, shallowEqual);

  // props 데이터
  // const datas = props.data.data.data;
  const [datas, setDatas] = useState([]);

  const [totalPages, setTotalPages] = useState();

  const [thisCurrentPage, setThisCurrentPage] = useState<number>();

  useEffect(() => {
    setThisCurrentPage(props.currentPage);
  }, [props.currentPage]);

  useEffect(() => {
    setDatas(props.data.data.data);
    setTotalPages(props.data.data.meta.totalPages);
    // 전체 페이지 보다 현재 선택된 페이지가 클경우 api setting고 현재 페이지를 재세팅
    if (props.data.data.meta.totalPages < props.currentPage!) {
      setThisCurrentPage(props.data.data.meta.totalPages);
      // props.onClick!(props.data.data.meta.totalPages);
    }
  }, [props.data]);

  // const { totalPages } = page;

  // 클릭 이벤트 세팅
  const objectChange = (currentPage: number) => {
    props.onClick!(currentPage);
  };

  const changeBrandCode = (code: string) => {
    let value = "";

    if (code.toUpperCase().startsWith("M")) {
      value = "MLB";
    } else if (code.toUpperCase().startsWith("X")) {
      value = "Discovery";
    } else if (code.toUpperCase().startsWith("I")) {
      value = "MLB KIDS";
    } else if (code.toUpperCase().startsWith("A")) {
      value = "STRETCH ANGELS";
    } else if (code.toUpperCase().startsWith("V")) {
      value = "DUVETICA";
    } else if (code.toUpperCase().startsWith("ST")) {
      value = "Sergio Tacchini";
    } else {
      value = "SUPRA";
    }

    return value;
  };

  return (
    <>
      {datas.length > 0 ? (
        <>
          {datas.map((v: any, idx: any) => {
            return (
              <li key={idx}>
                <AsListItemSet onClick={() => props.asDetailClick(v.as_idx)}>
                  <div className="category-info">
                    <p className="category">{v.cate_name}</p>
                    <StatusTag value={v.progress_name} level={v.progress_value} cancel={v.delete_yn === "Y"} />
                  </div>
                  <div className="content-info">
                    <p className="summary">
                      {v.copy_yn === "Y" ? <RemarkCom>{v.company_name}</RemarkCom> : ""}
                      {v.contents}
                    </p>
                  </div>
                  <div className="sub-info">
                    <p>
                      <span className="shop-code">{changeBrandCode(v.store_id)}</span>
                      <span className="shop-name">
                        {v.store_name}
                        {v.new_yn === "Y" && <SVG name="new" width={10} height={16} viewBox="0 0 10 16" />}
                      </span>
                      <span className="shop-type">{v.store_type}</span>
                    </p>
                    <p>
                      <span className="date">{moment(v.insert_date).format("YYYY.MM.DD")}</span>
                      <span className={cn("chat", { new: v.comment_read_yn === "N" })}>
                        {v.comment_read_yn === "N" ? (
                          <SVG name="chatActive" width={12.967} height={13.205} viewBox="0 0 12.967 13.205" />
                        ) : (
                          <SVG name="chat" width={12.967} height={13.205} viewBox="0 0 12.967 13.205" />
                        )}
                        {v.commentCount}
                      </span>
                    </p>
                  </div>
                </AsListItemSet>
              </li>
            );
          })}
        </>
      ) : (
        <NoResult>리스트 결과가 없습니다.</NoResult>
      )}

      {/* TODO asList로 이동 시킬껏 */}
      {totalPages !== undefined && totalPages > 1 && (
        <li>
          <BottomPadding className={cn({ withFixedBtn: userInfo.user_type === "S" })}>
            <PaginationCommon item_count={10} total_page={totalPages} current_page={thisCurrentPage} objectChange={objectChange} />
          </BottomPadding>
        </li>
      )}
    </>
  );
};

const NoResult = styled.li`
  margin: 80px 0 40px;
  text-align: center;
`;

const AsListItemSet = styled.div`
  display: block;
  padding: 16px 0;
  > div:first-child {
    ${({ theme }) => theme.flexBox.flexMixin()}
  }
  > div:last-child {
    ${({ theme }) => theme.flexBox.flexMixin("row", "space-between", "flex-end")}
  }
  .category-info {
    .category {
      color: ${({ theme }) => theme.color.primary};
      font-size: 16px;
      font-weight: 700;
      & + .summary {
        margin-top: 12px;
        color: ${({ theme }) => theme.color.primary};
      }
    }
  }
  .content-info {
    margin-top: 16px;
    .summary {
      color: ${({ theme }) => theme.color.primary};
      ${({ theme }) => theme.textOverflow.singleLine()}
    }
  }
  .sub-info {
    margin-top: 10px;
    .shop-code {
      display: block;
      color: #747474;
      margin-bottom: 3px;
      font-size: 12px;
      /* & + .shop-name {
        position: relative;
        margin-left: 10px;
        padding-left: 10px;
        &::after {
          position: absolute;
          left: -1px;
          top: 1px;
          content: "";
          display: block;
          width: 2px;
          height: 16px;
          background-color: ${({ theme }) => theme.color.lineSecondary};
        }
      } */
    }
    .shop-name {
      color: #000;
      margin-right: 10px;
      > svg {
        position: relative;
        top: -1px;
        margin-left: 3px;
      }
      & + .shop-type {
        position: relative;
        padding-left: 10px;
        color: ${({ theme }) => theme.color.lineSecondary};
        &::after {
          position: absolute;
          left: -1px;
          top: 1px;
          content: "";
          display: block;
          width: 2px;
          height: 16px;
          background-color: ${({ theme }) => theme.color.lineSecondary};
        }
      }
    }
    .date {
      padding-right: 16px;
      color: #747474;
      font-family: "Poppins";
      font-weight: 400;
    }
    .chat {
      padding-left: 4px;
      flex-shrink: 0;
      color: #747474;
      font-family: "Poppins";
      font-weight: 400;
      &.new {
        color: ${({ theme }) => theme.color.subMain};
      }
      > svg {
        position: relative;
        left: -4px;
        top: -1px;
      }
    }
  }
`;

const RemarkCom = styled.span`
  display: inline-block;
  padding: 2px;
  margin-right: 8px;
  background-color: #dbe1f4;
  font-size: 12px;
  line-height: 1;
  text-align: center;
`;

const BottomPadding = styled.div`
  &.withFixedBtn {
    padding-bottom: 60px;
  }
`;

export default AsListItem;
